var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "roll-fade"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "popover_helper"
  }, [_c('div', {
    staticClass: "popover",
    style: (_vm.popoverSettings)
  }, [_c('div', {
    staticClass: "popover-content",
    domProps: {
      "innerHTML": _vm._s(_vm.msg)
    }
  })])]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d68cfb96","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dynamic/HelpPopover.vue
// module id = 1521
// module chunks = 1